/**
 * Fully download + decode images before resolve so they can paint in one shot
 * (avoids progressive / line-by-line reveal when the list mounts).
 */
export function preloadImages(urls: string[]): Promise<void> {
  const unique = [...new Set(urls.filter((url) => Boolean(url && url.trim())))];

  if (unique.length === 0) {
    return Promise.resolve();
  }

  return Promise.all(
    unique.map(
      (url) =>
        new Promise<void>((resolve) => {
          const img = new window.Image();
          img.decoding = 'async';

          const finish = () => resolve();

          img.onload = () => {
            // Prefer full decode so the first paint is complete pixels.
            if (typeof img.decode === 'function') {
              img.decode().then(finish).catch(finish);
            } else {
              finish();
            }
          };
          img.onerror = finish;
          img.src = url;

          // Cached images may already be complete
          if (img.complete && img.naturalWidth > 0) {
            if (typeof img.decode === 'function') {
              img.decode().then(finish).catch(finish);
            } else {
              finish();
            }
          }
        }),
    ),
  ).then(() => undefined);
}
